import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/projects";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative scroll-mt-24 border-t border-line bg-surface px-6 py-28 sm:px-10 sm:py-40"
    >
      <div className="mx-auto max-w-[1600px]">
        <Reveal>
          <span className="text-[0.7rem] uppercase tracking-[0.28em] text-gold">
            005 — Contact
          </span>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal delay={0.05}>
              <h2 className="font-serif text-5xl font-light leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
                Have an idea?
                <br />
                Let's <span className="italic text-oxblood">cook.</span>
              </h2>
            </Reveal>
          </div>

          <div className="flex flex-col justify-end gap-10 lg:col-span-5">
            <Reveal delay={0.12}>
              <div>
                <p className="text-[0.7rem] uppercase tracking-[0.24em] text-ink-soft">Email</p>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="contact-email-link"
                  className="mt-2 block font-serif text-2xl text-ink transition-colors hover:text-oxblood sm:text-3xl"
                >
                  {CONTACT.email}
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <div>
                <p className="text-[0.7rem] uppercase tracking-[0.24em] text-ink-soft">Instagram</p>
                <a
                  href={CONTACT.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-instagram-link"
                  className="mt-2 block font-serif text-2xl text-ink transition-colors hover:text-oxblood sm:text-3xl"
                >
                  {CONTACT.instagramHandle}
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.24}>
              <p className="font-serif text-lg italic text-ink-soft">
                Signed, with flour on the hands — Pavitra, Head Chef.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
